"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProfessionParsedResponse = void 0;
function transformProfessionParsedResponse(profession) {
    return {
        id: profession.id.toString(),
        title: profession.title,
        company: profession.company,
        designation: profession.designation,
        businessId: profession.business_id !== null ? profession.business_id.toString() : null,
    };
}
exports.transformProfessionParsedResponse = transformProfessionParsedResponse;
//# sourceMappingURL=Profession.js.map